import { Column, Row } from "@stenajs-webui/core";
import { FlatButton, stenaMinusCircle } from "@stenajs-webui/elements";
import type { FC } from "react";
import { useDispatch } from "react-redux";

import { DetailsFieldCell } from "../../../common-ui/details/DetailsFieldCell";
import { Arrow } from "../../../common-ui/goods/Arrow";
import { MAX_LENGTH_GOODS_WEIGHT } from "../../../common/fieldLengths";
import { trackEvent } from "../../../common/tracking/trackerService";
import {
  type CreateIntermodalBookingGoodFormModel,
  removeCreateIntermodalBookingGood,
} from "../../../services/intermodal/createIntermodalReducer";
import type { GoodsTypesQueryRefProps } from "../../../services/intermodal/hooks/useGoodsTypes";
import { CreateIntermodalGoodsValidationWrapper } from "./CreateIntermodalValidationWrapper";
import { CreateGoodsTypeDropdown } from "./fields/CreateGoodsTypeDropdown";
import { CreateGoodsWeightInput } from "./fields/CreateGoodsWeightInput";

interface Props extends GoodsTypesQueryRefProps {
  editable: boolean;
  value: CreateIntermodalBookingGoodFormModel;
}

export const CreateBookingGoodsItem: FC<Props> = ({
  value,
  editable,
  goodsTypesQueryRef,
}) => {
  const dispatch = useDispatch();

  return (
    <Column gap={2}>
      <CreateIntermodalGoodsValidationWrapper
        name={"goodsType"}
        goodId={value.id}
        renderField={(isValid) => (
          <DetailsFieldCell
            label="Goods description"
            renderField={(id) => (
              <CreateGoodsTypeDropdown
                id={id}
                isValid={isValid}
                goodsId={value.id}
                trackerCategory={"IntermodalCreate"}
                goodsTypesQueryRef={goodsTypesQueryRef}
              />
            )}
          />
        )}
      />
      <CreateIntermodalGoodsValidationWrapper
        name={"weight"}
        goodId={value.id}
        renderField={(isValid) => (
          <Row alignItems={"start"} gap={1}>
            <Arrow />
            <DetailsFieldCell
              label={"Weight (kg)"}
              renderField={(id) => (
                <Row gap={1} alignItems={"center"}>
                  <CreateGoodsWeightInput
                    id={id}
                    goodsId={value.id}
                    maxLength={MAX_LENGTH_GOODS_WEIGHT}
                    isValid={isValid}
                    trackerCategory={"IntermodalCreate"}
                  />
                  {editable && (
                    <FlatButton
                      variant={"danger"}
                      leftIcon={stenaMinusCircle}
                      onClick={() => {
                        trackEvent({
                          category: "IntermodalCreate",
                          action: "Remove goods",
                        });
                        dispatch(
                          removeCreateIntermodalBookingGood({ id: value.id }),
                        );
                      }}
                    />
                  )}
                </Row>
              )}
            />
          </Row>
        )}
      />
    </Column>
  );
};
